module.exports = __webpack_public_path__ + "media/images/countrysquared/us-48140eef57002be7a0d8de05823b2674.svg";